/**
 * 处理04异常
 * context当前this，为了使用$UserService。不然又得自己写登出函数logout
 */

export const handleErrorUser = ({ err, isLoginOut = true, context }) => {
  const { code, msg } = err || {}
  if (code === '04') {
    if (msg) {
      if (isLoginOut && context) {
        context.$UserService.logout().then(() => {
          setTimeout(() => {
            window.location.href = msg
          }, 1000)
        })
      } else {
        setTimeout(() => {
          window.location.href = msg
        }, 1000)
      }
    }
  }
}
